export type KeyVisibilityField = 'apiAccessKey' | 'registrationKey';

export function createDefaultKeyVisibility(): Record<KeyVisibilityField, boolean> {
  return {
    apiAccessKey: false,
    registrationKey: false,
  };
}

export function getDescriptionByStep(activeStep: 1 | 2): string {
  const STEP_DESCRIPTIONS = {
    1: 'Provide details. Keys will be generated in the next step.',
    2: 'Securely store your access credentials to proceed with deployment.',
  } as const;
  return STEP_DESCRIPTIONS[activeStep] ?? '';
}

const MASKED_VALUE_VISIBLE_EDGE_LENGTH = 4;
const MASKED_VALUE_MIDDLE = '*****';

/**
 * Masks a secret as `<first 4><*****><last 4>` — the same format the API returns
 * for an existing capsule's keys (e.g. `1cd8*****3d9c`). Keeping a single rule
 * means creation-time masking (Access Credentials fields, Helm command preview)
 * matches what users later see on the capsule detail screen. Short values that
 * can't show both edges without overlap fall back to the bare mask.
 */
export function getMaskedValue(secretValue: string): string {
  if (!secretValue) return '';

  if (secretValue.length <= MASKED_VALUE_VISIBLE_EDGE_LENGTH * 2) {
    return MASKED_VALUE_MIDDLE;
  }

  const prefix = secretValue.slice(0, MASKED_VALUE_VISIBLE_EDGE_LENGTH);
  const suffix = secretValue.slice(-MASKED_VALUE_VISIBLE_EDGE_LENGTH);
  return `${prefix}${MASKED_VALUE_MIDDLE}${suffix}`;
}
